import { useQuery } from '@tanstack/react-query';
import { api } from '@/auth/api';
import type { DriverLocation } from '@breaker/shared-types';

/**
 * Driver location points for a load, chronological (earliest first;
 * the LAST element is the most recent fix). Consumes the dispatcher-gated
 * read built in Phase 4.75d:
 *
 *   GET /v1/fleets/:fleetId/loads/:loadId/locations
 *
 * Key inlined to match useLoadHistory / useTrackingLinks (the sibling
 * load sub-resource hooks) rather than extending the qk factory.
 */
export function useLoadLocations(
  fleetId: string | null,
  loadId: string | null,
) {
  return useQuery({
    queryKey: ['loads', fleetId ?? '', 'locations', loadId ?? ''] as const,
    enabled: Boolean(fleetId && loadId),
    queryFn: () =>
      api<{ locations: DriverLocation[] }>(
        `/v1/fleets/${fleetId}/loads/${loadId}/locations`,
      ),
    select: (data) => data.locations,
  });
}
